import validator from 'validator';

const validatedownloadExcel = (data) => {
  let errors = {}

  const {category1} = data;
  if(validator.isEmpty(category1)) {
    errors.category1 =  "Please select Excel Category";
  }
 
 
  return {
    isInvalid: Object.keys(errors).length >0,
    error: errors
  }
}

export default validatedownloadExcel;